import { useTranslation } from "react-i18next"
import moment from "moment"
import { Button, Flex } from "antd"
import { Text, Title } from "ui/Typography"
import IconWithBg from "ui/IconWithBg"
import { LeftOutlined } from "@ant-design/icons"
import PropTypes from "prop-types"

const TemplateCardExtra = ({ created_at, setSelectedLog }) => {
  const { t } = useTranslation()
  return (
    <Flex align="center" justify="space-between">
      <Button className="px-0" onClick={() => setSelectedLog(null)} type="text" icon={<IconWithBg icon={<LeftOutlined />} />}>
        <Title level={4}>{t("global.back")}</Title>
      </Button>
      <Text>Sent on {created_at && moment(created_at).format("MM/DD/YY hh:mm A")}</Text>
    </Flex>
  )
}

TemplateCardExtra.propTypes = {
  created_at: PropTypes.string.isRequired,
  setSelectedLog: PropTypes.func.isRequired
}

export default TemplateCardExtra
